import DSButton from './src'

export default DSButton
